// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyCv1fMyCf_xEIY4MoOOffMnSj87gLeSEJo",
  authDomain: "boakyeagyarko2024.firebaseapp.com",
  projectId: "boakyeagyarko2024",
  storageBucket: "boakyeagyarko2024.appspot.com",
  messagingSenderId: "947219704307",
  appId: "1:947219704307:web:b291bbe5dcab449711ca86",
  measurementId: "G-SVG3B81B3P",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
